module.exports = __webpack_public_path__ + "static/img/ent-detail-10.f72b82d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-10.jpg
// module id = 2Ylf
// module chunks = 51